<script>
import LeftMenuItem from './LeftMenuItem';
import LeftMenuComponent from './LeftMenuComponent';
export default {
  functional: true,
  inject: ['menu'],
  render(_, { props, scopedSlots, data, injections }) {
    const { opened, toggleOpened, collapse, isOverseasVersion, toProjectList } = injections.menu;
    const isOpened = opened.includes(props.item.name);
    const onToggleClick = (e) => {
      stopPropagation(e);
      toggleOpened(props.item);
    };
    const stopPropagation = (e) => {
      e.stopPropagation();
    };
    const onMenuItemClick = () => {
      if (props.item.name === 'support-center') {
        toggleOpened(props.item);
      } else {
        toProjectList(props.item);
      }
    };
    return isOverseasVersion ? <div class="zk-left-submenu">
      <LeftMenuItem item={props.item} onClick={onMenuItemClick} scopedSlots={{
        ...scopedSlots,

        suffix: (...args) => {
          const suffixIcon = collapse ? null : <span class='zk-left-submenu-suffix-icon'>
            <em onClick={onToggleClick} onMousedown={stopPropagation} class={['zkicon', isOpened ? 'iconzhankai_shi' : 'iconxiangyouzhankai']}/></span>;
          if (scopedSlots.suffix) {
            return [
              Reflect.apply(scopedSlots.suffix, null, args),
              suffixIcon
            ];
          }
          return suffixIcon;
        }
      }} />
      <el-collapse-transition>
        <div key={isOpened ? '1' : '2'} style={{ display: isOpened ? 'block' : 'none' }}>
          {
            props.item.children.map(item => <LeftMenuComponent item={item} key={item.name} scopedSlots={scopedSlots} {...{ on: data.on }} />)
          }
        </div>
      </el-collapse-transition>
    </div> :
      <div class="zk-left-submenu">
        <LeftMenuItem item={props.item} onClick={() => toggleOpened(props.item)} scopedSlots={{
          ...scopedSlots,
          suffix: (...args) => {
            const suffixIcon = collapse ? null : <em class={['zkicon', isOpened ? 'iconzhankai_shi' : 'iconxiangyouzhankai']}/>;
            if (scopedSlots.suffix) {
              return [
                Reflect.apply(scopedSlots.suffix, null, args),
                suffixIcon
              ];
            }
            return suffixIcon;
          }
        }} />
        <el-collapse-transition>
          <div key={isOpened ? '1' : '2'} style={{ display: isOpened ? 'block' : 'none' }}>
            {
              props.item.children.map(item => <LeftMenuComponent item={item} key={item.name} scopedSlots={scopedSlots} {...{ on: data.on }} />)
            }
          </div>
        </el-collapse-transition>
      </div>;
  }
};
</script>

<style lang="scss">
@include b(left-submenu) {
  > div {
    .zk-left-menu-item {
      height: 36px;
      line-height: 36px;
      .zk-left-menu-item__content {
        padding-left: 42px;
      }
    }
  }
  .zk-left-submenu-suffix-icon{
    width: 18px;
    height: 18px;
    border-radius: var(--radius-mini);
    display: flex;
    align-items: center;
    &:hover {
      background-color: #73728d;
    }
    .zkicon {
      font-size: 18px;
    }
  }

}
</style>
